<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Ventas</h1>
                <div class="caption">
                    Muestra las ventas del grupo en el periodo seleccionado en pesos o en dólares, como un total y detallado por empresa.
                    Toma valores sin impuestos a fecha de emisión. Solo considera facturas, débitos y créditos.
                    El valor de cambio del dólar se toma a la fecha de emisión de comprobante. Permite excluir operaciones intercompany.
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <empresa-select v-model="d.empresa" multiple label="Empresa"></empresa-select>
                        <empresa-select v-model="d.excluir" multiple label="Excluir empresa"></empresa-select>
                        <moneda-select v-model="d.moneda"></moneda-select>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="menuHasta"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(date)"
                            ></v-date-picker>
                        </v-menu>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-menu
                        v-model="seriesShow"
                        :position-x="x"
                        :position-y="y"
                        absolute
                        offset-y
                >
                    <v-card raised>
                        <v-card-text>
                            <highcharts style="width: 100%" :options="chartSeriesOptions"></highcharts>
                        </v-card-text>
                    </v-card>
                </v-menu>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import {mapActions} from 'vuex';
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import monedaSelect from '../../components/MonedaSelect.vue'
    import moment from 'moment';

    export default {
        components: {empresaSelect, monedaSelect},
        data() {
            return {
                seriesShow: false,
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                monedas: [],
                x: 0,
                y: 0,
                serieName: '',
                d: {
                    empresa: [],
                    excluir: [],
                    moneda: 1,
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD')
                },
                chartOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x'
                    },
                    title: {
                        text: 'VENTAS'
                    },
                    legend: {
                        labelFormat: '{name}'
                    },
                    tooltip: {
                        pointFormat: '{series.name} | {point.compl}: <b>{point.percentage:.1f}% </b>Monto: <b>{point.y:,.1f}</b>'
                    },
                    xAxis: {
                        type: 'category',
                        title: {
                            text: 'Meses'
                        },
                        labels: {
                            rotation: -45,
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        },
                        stackLabels: {
                            enabled: true,
                            rotation: -45,
                            align: 'right',
                            style: {
                                fontWeight: 'bold',
                                color: 'gray'
                            },
                            format: '{total:,.2f}'
                        }
                    },
                    plotOptions: {
                        column: {
                            stacking: true,
                            grouping: true,
                            dataLabels: {
                                align: 'left',
                                enabled: false,
                                rotation: -45,
                                format: '{y:,.2f}'
                            }
                        },
                        series: {
                            point: {
                                events: {
                                    click: (e) => {
                                        console.log(e);
                                        this.x = e.x;
                                        this.y = e.y;
                                        this.serieName = e.point.name;
                                        this.traeSeries(e.point.ano, e.point.mes, e.point.emp)
                                    }
                                }
                            }
                        }
                    },
                    series: []
                },
                chartSeriesOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x'
                    },
                    title: {
                        text: 'VENTAS POR VENDEDOR'
                    },
                    legend: {
                        enabled: false
                    },
                    tooltip: {
                        pointFormat: '{series.name} | {point.compl}: Monto: <b>{point.y:,.2f}</b>'
                    },
                    xAxis: {
                        type: 'category',
                        title: {text: 'Vendedores'}
                    },
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        },
                        stackLabels: {
                            enabled: true,
                            rotation: -45,
                            style: {
                                fontWeight: 'bold',
                                color: 'gray'
                            },
                            format: '{total:,.2f}'
                        },
                    },
                    plotOptions: {
                        column: {
                            stacking: false,
                            dataLabels:
                                {
                                    enabled: true,
                                    align: 'left',
                                    rotation: -45,
                                    style: {
                                        fontWeight: 'bold',
                                        color: 'gray'
                                    },
                                    format: '{y:,.2f}'
                                }
                        }
                    },
                    series: []
                }
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/venta', this.d)
                    .then(r => {
                        this.chartOptions.series = r.data.grafico;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        alert(r);
                        this.loading = false;
                    });
            },
            traeSeries(ano, mes, emp) {
                this.loading = true;
                this.$http.post('indicadores/venta-vendedor', {
                    ano: ano,
                    mes: mes,
                    emp: emp,
                    moneda: this.d.moneda
                })
                    .then(r => {
                        this.chartSeriesOptions.series = r.data;
                        this.loading = false;
                        this.lateral = false;
                        this.$nextTick(() => {
                            this.seriesShow = true
                        });
                    }, r => {
                        alert(r);
                        this.loading = false;
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/venta.vue